import { nameOf } from "../../Utils/nameOf";
import { Edc } from "../Edc";
import { EdcFormTabs } from "./EdcFormTabs";
import { useAddEdc } from "../Hooks/useAddEdc";
import { edcDefaultValues } from "./edcDefaultValues";

export const AddEdc = () => {
  const { mutate: addEdc } = useAddEdc();

  const disabledFields: Array<string> = [
    nameOf<Edc>("MgLatitude"),
    nameOf<Edc>("MgLongitude"),
    nameOf<Edc>("AltMgLatitude"),
    nameOf<Edc>("AltMgLongitude"),
  ];

  return (
    <EdcFormTabs
      title="Add EDC"
      edc={edcDefaultValues}
      onSave={(it: Edc) => {
        addEdc(it);
      }}
      disabledFields={disabledFields}
    />
  );
};
